import { doGet, doPost } from 'circe/Http/saga';
import { operatorClient, shippingClient, reportingClient } from 'domain/HttpClients';
import { TAGS } from 'domain/productType/components/create/constants';

export const fetch = (cursor) =>
  operatorClient
    .Get('/api/shipments')
    .withParams({ cursor, domain: SYSTEM_DOMAIN })
    .send();

export const requestUpdateAddress = (domainId, payload) =>
  operatorClient
    .Post('/api/notifications')
    .withParams({ domainId })
    .withData(payload)
    .send();

export const generateOTP = (payload) =>
  shippingClient
    .Post('/api/confirmation/otp/generate')
    .withData(payload)
    .send();

export const batchSalesOrders = (formData, headers) =>
  doPost(
    '/api/masheed/batch-sales-orders/create-shipments',
    formData,
    headers,
    {},
    OPERATIONS_EDGE,
    false,
    true,
  );

export const downloadReport = (params) =>
  reportingClient
    .Get('/api/dashboards/waybills-info/sendEmail-csv')
    .withParams(params)
    .send();

export const downloadShipmentWaybills = (shipments) =>
  shippingClient
    .Get(
      `/api/shipments/get-shipments-label-link?${shipments
        .map((shipment) => `shipment-ids=${shipment}`)
        .join('&')}`,
    )
    .send();

export const getWaybillDestination = (waybill) =>
  shippingClient.Get(`/api/waybills/${waybill}/history?waybill=${waybill}`).send();

export const getShippers = async (key, account = null) => {
  try {
    const response = await operatorClient
      .Get('api/shippers')
      .withParams({ did: SYSTEM_DOMAIN, firstName: key, aid: account })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
      subLabel: row.company,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};
export const unscheduleTrip = async (payload) =>
  operatorClient
    .Post('/api/fleets/management/unschedule')
    .withData({ itineraryId: payload })
    .send();

export const getFleets = async (key, isShipperCompany = false) => {
  try {
    const response = await operatorClient
      .Get('api/accounts')
      .withParams({ name: key, type: isShipperCompany ? 'SHIPPER' : 'COURIER,PRIMARY_COURIER' })
      .send();
    const output = response.results.map((row) => ({
      value: row.key,
      label: row.value.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getSalesCategories = async (vehicleTypes = []) => {
  try {
    const response = await operatorClient
      .Get('api/masheed/constant/sales-categories')
      .withParams({ vehicleTypes: `${vehicleTypes}` })
      .send();
    const output = response.map((row) => {
      const tagLabel = TAGS.filter((tag) => tag.value === row?.tag);
      return {
        value: row.salesCategory,
        label: row.salesCategory,
        subLabel: tagLabel[0]?.label || '',
        truckType: row?.truckType,
      };
    });
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getDrivers = async (key, fleet = null) => {
  try {
    const response = await operatorClient
      .Get('api/drivers')
      .withParams({ name: key, aid: fleet })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
      subLabel: row.company,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getWaybillSortingData = (waybill) =>
  operatorClient
    .Get('/api/shipments/sort')
    .withParams({ waybill })
    .send();

export const forceUpdateWaybillsStatus = async (status, waybills, profileId, message) => {
  try {
    const response = await operatorClient
      .Post('/api/shipments/external-status-update')
      .withData({
        toStatus: status,
        toState: status,
        waybills,
        profileId,
        message,
      })
      .send();
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const downloadWaybillsReport = async (filters) => {
  try {
    const response = await reportingClient
      .Post('/api/dashboards/waybills-info/sendEmail-csv')
      .withData(filters)
      .send();
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const revertExceptionWaybills = async (waybills, profileId, message) => {
  try {
    const response = await operatorClient
      .Post('/api/shipments/revert-exception-status')
      .withData({
        waybills,
        profileId,
        message,
      })
      .send();
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getAddresses = async (name) => {
  try {
    const response = await shippingClient
      .Get('/api/address/v3/search')
      .withParams({
        names: name,
      })
      .send();

    return response.results.map((item) => {
      return {
        label: `${item.code} - ${item.name}`,
        value: item,
      };
    });
  } catch (e) {
    console.error(e);
    return [];
  }
};
